// localforage (~90 KB source) is only needed for IndexedDB caches, so it loads on first use instead of with the main bundle.
let instance;

function getLocalForage() {
    instance ??= import('localforage').then(({ default: localForage }) => {
        localForage.config({
            driver: localForage.INDEXEDDB,
            name: 'loise',
            version: 1.0,
            storeName: 'cache',
        });
        return localForage;
    });
    return instance;
}

export { getLocalForage };
